module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.item) ? _c('div', {
    staticClass: "component-credit-record-action-buttons"
  }, [_c('div', {
    staticClass: "dropdown-buttons"
  }, [_c('PacketRecordUsageReveal', {
    attrs: {
      "item": _vm.item
    }
  })], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6f781f1c!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/PacketRecordButtons.vue
// module id = 2580
// module chunks = 1